// Basic global JavaScript for Shopify theme
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open() {
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('cart-drawer', CartDrawer);

// Add to cart functionality
function addToCart(form) {
  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    // Handle success - could open cart drawer, show notification, etc.
    console.log('Added to cart:', data);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  });
}